export default function Arrow() {
    return (
        <svg className="sidebar-item__arrow" xmlns="http://www.w3.org/2000/svg" width="17.702" height="18.349" viewBox="0 0 17.702 18.349">
            <path id="Path_57" data-name="Path 57" d="M14.211,17.959l6.1-6.151,1.609,1.622-8.851,8.92-8.851-8.92,1.609-1.622,6.1,6.151V4h2.276Z" transform="translate(-4.222 -4)" fill="#cecece"/>
        </svg>
    )
}